import { findLastDeployedVersion } from '.';
import { SolutionVersion } from '../xstate/prostudio.api-service.types';

// @DEPRECATED currently we have draftVersion in the getBotById response
export const findDraftVersion = (
  deployedVersions: string[],
  history: SolutionVersion[]
): string => {
  const historyVersions = new Set(history.map((item) => item.version));
  const draftVersion = deployedVersions
    .filter((version) => !historyVersions.has(version))
    .sort((a, b) =>
      b.localeCompare(a, undefined, {
        numeric: true,
      })
    )[0];

  return draftVersion || findLastDeployedVersion(deployedVersions);
};
